/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { ProcedureItem } from '../../models/procedure-item';
import { ProcedureStatusChangeDto } from '../../models/procedure-status-change-dto';

export interface ProcedureControllerUpdateProcedureStatus$Params {
  id: number;
      body: ProcedureStatusChangeDto
}

export function procedureControllerUpdateProcedureStatus(http: HttpClient, rootUrl: string, params: ProcedureControllerUpdateProcedureStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProcedureItem;
}>> {
  const rb = new RequestBuilder(rootUrl, procedureControllerUpdateProcedureStatus.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: ProcedureItem;
      }>;
    })
  );
}

procedureControllerUpdateProcedureStatus.PATH = '/procedure/{id}/status';
